// Toggle Header Sign in Popover
$('.hpe-nav__item').click(function (event) {
  event.stopPropagation();
  $('.hpe-nav__item').removeClass('hpe-nav__item--active');
  $(this).toggleClass('hpe-nav__item--active');
});

$('body').click(function () {
  $('.hpe-nav__item').removeClass('hpe-nav__item--active');
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/nav-item.js